import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectOrdersListItems } from "../../../../redux/orders/selector";
import { selectListItems } from "../../../../redux/library/selector";
import { orders } from "../../../../redux/orders/action";
import { LibraryRendererComponent } from "../../../../common/components/library-renderer-1.0.component";
import { format } from "../../../../common/services/common.service";

const ShippingList = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const itemsData = useSelector(selectOrdersListItems)
    const libraryData = useSelector(selectListItems)
    const [pageSize, setPageSize] = useState(10);

    const fetchOrders = () => {
        dispatch(orders.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/list`, entity: 'order', jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
            }
        }))
    }




    useEffect(() => {

        fetchOrders()
    }, [pageData, pageSize])


    const handleMore = (data: any) => {
        navigate("/customer/logistics/transport/shipments")
    }
    return (
        <>
            {itemsData?.isLoading ? <h1>Loading...</h1>
                :
                <>


                    <div className="flex items-center justify-end items-end mb-4">

                        <button className="border border-neutral-800 px-4 py-2 rounded" onClick={handleMore}>
                            More Details..
                        </button>
                    </div>
                    <div className="overflow-auto w-full">
                        <table className="min-w-full text-sm text-left bg-red-50 p-2 rounded-md">
                            <thead className="w-auto text-center">
                                <tr className="bg-red-100 h-12 leading-normal">
                                    <th className="py-3 px-6 text-left border-r border-gray-100">Shipment PId</th>
                                    <th className="py-3 px-6 text-left border-r border-gray-100">Tracking ID</th>
                                    <th className="py-3 px-6 text-left border-r border-gray-100">Shipment Status</th>
                                    <th className="py-3 px-6 text-left border-r border-gray-100">Agent Name</th>

                                    <th className="py-3 px-6 text-left">Delivery Date</th>

                                </tr>
                            </thead>
                            <tbody>
                                {itemsData?.result?.items?.map((data) => (
                                    <tr key={data?.Message?.Id} className=" border-b even:bg-[#F8F9FAFF] odd:bg-white">
                                        <td className="px-5 py-2">{data?.Message?.ShipmentPId}</td>
                                        <td className="px-5 py-2">{data?.Message?.TrackingNumber}</td>
                                        <td className="px-5 py-2 ">
                                            <div className='flex justify-center items-center'><LibraryRendererComponent
                                                cellRendererParams={{ library: libraryData?.result?.ShippingStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' }}
                                                value={data?.Message?.ShippingStatusId}
                                            /> </div></td>
                                        <td className=" px-5 py-2">{data?.Message?.AgentName}</td>

                                        <td className="px-5 py-2">{format(data?.Message?.DeliveryDateUtc)}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </>
            }
        </>



    );
};

export default ShippingList;


